import styled from "styled-components";

const StyledLinkButton = styled.button`
  display: inline-block;
  border: none;
  background: none;
  margin: 0;
  padding: 0;
  font: inherit;
  text-align: inherit;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.link};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }

  .forward-chevron {
    display: ${({ theme }) =>
      theme.forwardLinkHasChevron ? "inline-block" : "none"};
  }

  img {
    display: inline-block;
  }

  .back-chevron {
    display: inline-block;
    /* ${({ theme }) =>
      theme.backLinkHasChevron ? "inline-block" : "none"}; */
  }

  img:first-child {
    transform: rotate(180deg);
    margin-right: ${({ theme }) => theme.linkChevronMargin};
  }

  img:last-child {
    margin-left: ${({ theme }) => theme.linkChevronMargin};
  }
`;

export default StyledLinkButton;
